export default "__VITE_ASSET__DOjzxn_$__"